import { CssBaseline, ThemeProvider } from '@mui/material';
import { useGetOrganizations } from 'apis/agency/organizations/hook';
import { useEffect, useState } from 'react';
import { CacheKeys } from 'utils/cacheKeys';
import { getCookie, setCookie } from 'utils/helperFunctions';
import { getTheme } from 'utils/theme/theme';

export const DynamicThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const storedThemeColor = getCookie(CacheKeys.themeColor);
  const [currentTheme, setCurrentTheme] = useState<string>(storedThemeColor || '#4B22A8');
  const { data: organizations } = useGetOrganizations();

  useEffect(() => {
    const orgColor = organizations?.configuration?.brand_color;

    if (orgColor && orgColor !== storedThemeColor) {
      setCurrentTheme(orgColor);
      setCookie(CacheKeys.themeColor, orgColor); // update cookie
    }
  }, [storedThemeColor, organizations]);

  const theme = getTheme(currentTheme);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      {children}
    </ThemeProvider>
  );
};
